import './style.css';

/* Html like this should be for this module:
<div class="reg-form__input offset-m country-code-container">
    <input class="input input_width_m country-code-input" id="attendeeEmailOrPhoneNumber" type="text" placeholder="Your email" />
    <div class="country-code-selector" style="display:none;">
        <div class="country-code-selector__selected" data-code="US">US +1</div>
        <div class="country-code-selector__options">
<!--        <div class="country-code-selector__option" data-code="US">United States +1</div>-->
<!--        <div class="country-code-selector__option" data-code="AF">Afghanistan +93</div>-->
        </div>
    </div>
</div>
 */

// We are temporarily using this list until it’s enabled for everyone. Once that happens, the list can be sourced from the ./countryCodes.ts file.
const COUNTRY_CODES = [{ name: 'United States', dialCode: '+1', code: 'US' }];

export function initEmailOrPhoneInput({
  defaultCode = COUNTRY_CODES[0].code,
  placeholderOnlyEmail = 'Your email',
  placeholderEmailOrPhone = 'Your email or US phone number',
}: {
  defaultCode?: string;
  placeholderOnlyEmail?: string;
  placeholderEmailOrPhone?: string;
} = {}) {
  let cbOnChangeMode = (mode: string) => {};
  const select = document.querySelector('.country-code-selector') as HTMLElement;
  const input = document.querySelector('.country-code-input') as HTMLInputElement;
  const selected = document.querySelector('.country-code-selector__selected') as HTMLElement;
  const options = document.querySelector('.country-code-selector__options') as HTMLElement;

  input.setAttribute('placeholder', placeholderOnlyEmail);
  setCountryCode(defaultCode);
  renderOptions(COUNTRY_CODES);

  if (COUNTRY_CODES.length > 1) {
    select.addEventListener('click', () => {
      options.style.display = options.style.display === 'block' ? 'none' : 'block';
    });

    options.addEventListener('click', (e) => {
      const currentOption = (e.target as HTMLElement)?.closest('.country-code-selector__option');
      if (currentOption) {
        const code = currentOption.getAttribute('data-code');
        if (code) {
          setCountryCode(code);
          updateInputPadding();
        }
      }
    });

    document.addEventListener('click', (e) => {
      if (!select.contains(e.target as HTMLElement)) {
        options.style.display = 'none';
      }
    });
  }

  return {
    get,
    contentType,
    enablePhoneNumber,
    onChangeMode: (cb: (mode: string) => void) => {
      cbOnChangeMode = cb;
    },
  };

  function get() {
    if (isEnableCountryCode()) {
      const selectedCode = selected.getAttribute('data-code');
      if (!selectedCode) throw new Error('Country code is not found');

      const code = findCountryCodeByCode(selectedCode);
      if (!code) throw new Error('Country code is not found');

      return `${code.dialCode}${input.value}`.replace(/\s+/g, '');
    }
    return input.value.replace(/\s+/g, '');
  }

  function contentType() {
    const type = determineInputType(input.value);
    if (type === 'phoneWithCountryCode' || type === 'phoneWithoutCountryCode') return 'phone';
    if (type === 'email') return 'email';
    return '';
  }

  function setCountryCode(code: string) {
    const countryCode = findCountryCodeByCode(code);
    if (countryCode) {
      selected.textContent = `${countryCode.code} ${countryCode.dialCode}`;
      selected.setAttribute('data-code', countryCode.code);
    }
  }

  function renderOptions(countryCodes: { name: string; dialCode: string; code: string }[]) {
    const optionsHTML = countryCodes
      .map(
        (item: { name: string; dialCode: string; code: string }) =>
          `<div class="country-code-selector__option" data-code="${item.code}">${item.name} ${item.dialCode}</div>`
      )
      .join('');
    options.innerHTML = optionsHTML;
  }

  function findCountryCodeByCode(code: string) {
    return COUNTRY_CODES.find((item: { name: string; dialCode: string; code: string }) => item.code === code);
  }

  function updateInputPadding() {
    const width = selected.offsetWidth;
    input.style.paddingLeft = `${width}px`;
  }

  function removeInputPadding() {
    input.style.paddingLeft = '';
  }

  function showSelectCountryCode() {
    select.style.display = 'block';
    updateInputPadding();
  }

  function hideSelectCountryCode() {
    select.style.display = 'none';
    removeInputPadding();
  }

  function isEnableCountryCode() {
    return select.style.display === 'block';
  }

  function determineInputType(value: string) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneWithCountryCodeRegex = /^\+\d[\d\s]*$/;
    const phoneWithoutCountryCodeRegex = /^\d[\d\s]*$/;

    if (phoneWithCountryCodeRegex.test(value)) return 'phoneWithCountryCode';
    if (phoneWithoutCountryCodeRegex.test(value)) return 'phoneWithoutCountryCode';
    if (emailRegex.test(value)) return 'email';
    return 'invalid';
  }

  function enablePhoneNumber() {
    let prevState = '';
    input.setAttribute('placeholder', placeholderEmailOrPhone);

    input.addEventListener('input', (e) => {
      const inputType = determineInputType((e.target as HTMLInputElement)?.value.trim());
      if (inputType !== prevState) {
        if (inputType === 'phoneWithoutCountryCode') {
          showSelectCountryCode();
        } else {
          hideSelectCountryCode();
        }
        cbOnChangeMode(inputType);
        prevState = inputType;
      }
    });
  }
}
